<template>
  <div>
    <!--基本信息-->
    <div class="common-form">基本信息</div>
    <el-form-item
      label="商品名称："
      :rules="[{ required: true, message: '请填写商品名称' }]"
      prop="model.product_name"
    >
      <el-input v-model="form.model.product_name" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item
      label="合同商品名称："
      :rules="[
        { required: true, message: '请填写商品名称' },
        { min: 0, max: 30, message: '长度在 0 到 30 个字符', trigger: 'blur' }
      ]"
      prop="model.product_desc"
    >
      <el-input v-model="form.model.product_desc" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item
      label="所属分类："
      :rules="[{ required: true, message: '请选择商品分类' }]"
      prop="model.category_id"
    >
      <el-select v-model="form.model.category_id">
        <template v-for="cat in form.category">
          <el-option
            :value="cat.category_id"
            :key="cat.category_id"
            :label="cat.name"
          ></el-option>
          <template v-if="cat.child !== undefined" v-for="two in cat.child">
            <el-option
              :value="two.category_id"
              :key="two.category_id"
              :label="two.name"
              style="padding-left: 30px;"
            ></el-option>
            <template v-if="two.child !== undefined" v-for="three in two.child">
              <el-option
                :value="three.category_id"
                :key="three.category_id"
                :label="three.name"
                style="padding-left: 60px;"
              ></el-option>
            </template>
          </template>
        </template>
      </el-select>
    </el-form-item>
    <el-form-item label="销售状态：">
      <el-radio-group v-model="form.model.product_status">
        <el-radio :label="10">立即上架</el-radio>
        <el-radio :label="20">放入仓库</el-radio>
      </el-radio-group>
      <div class="gray9">如果平台开启了商品审核，则商品审核通过后才能销售</div>
    </el-form-item>
    <el-form-item
      label="是否审核："
      v-if="form.audit_setting.add_audit == 1 && form.scene == 'add'"
    >
      <el-radio-group v-model="form.model.audit_status">
        <el-radio :label="0">提交审核</el-radio>
        <el-radio :label="40">保存草稿</el-radio>
      </el-radio-group>
      <div class="gray9">当前平台开启了审核，审核通过后才能上架销售</div>
    </el-form-item>
    <el-form-item
      label="是否审核："
      v-if="form.audit_setting.edit_audit == 1 && form.scene != 'add'"
    >
      <el-radio-group v-model="form.model.audit_status">
        <el-radio :label="0">提交审核</el-radio>
        <el-radio :label="40">保存草稿</el-radio>
      </el-radio-group>
      <div class="gray9">当前平台开启了修改审核，审核通过后才能上架销售</div>
    </el-form-item>
    <!-- <el-form-item label="是否新机：">
      <el-radio-group v-model="form.model.new_machine">
        <el-radio :label="1">是</el-radio>
        <el-radio :label="2">否</el-radio>
      </el-radio-group>
    </el-form-item> -->
    <el-form-item
      label="商品图片："
      :rules="[{ required: true, message: '请上传商品图片' }]"
      prop="model.image"
    >
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.model.image">
          <transition-group>
            <div
              class="item"
              v-for="(item, index) in form.model.image"
              :key="item.file_path"
            >
              <img v-img-url="item.file_path" />
              <a
                href="javascript:void(0);"
                class="delete-btn"
                @click.stop="deleteImg(index)"
                ><i class="el-icon-close"></i
              ></a>
            </div>
          </transition-group>
        </draggable>
        <div
          class="item img-select"
          @click="openProductUpload('image', 'image')"
        >
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>

    <el-form-item
      label="商品热点："
      :rules="[{ required: true, message: '请上传商品图片' }]"
      prop="model.spimage"
    >
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.model.spimage">
          <transition-group>
            <div
              class="item"
              v-for="(item, index) in form.model.spimage"
              :key="item.file_path"
            >
              <img v-img-url="item.file_path" />
              <a
                href="javascript:void(0);"
                class="delete-btn"
                @click.stop="deleteImg2(index)"
                ><i class="el-icon-close"></i
              ></a>
            </div>
          </transition-group>
        </draggable>
        <div
          class="item img-select"
          @click="openProductUpload('image', 'spimage')"
        >
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>
    <!-- 
    <el-form-item label="商品视频：">
      <el-row>
        <div class="draggable-list">
          <div
            class="item img-select"
            v-if="form.model.video_id == 0"
            @click="openProductUpload('video', 'video')"
          >
            <i class="el-icon-plus"></i>
          </div>
          <div v-if="form.model.video_id != 0">
            <video
              width="150"
              height="150"
              :src="form.model.video.file_path"
              :autoplay="false"
              controls
            >
              您的浏览器不支持 video 标签
            </video>
            <div>
              <el-button icon="el-icon-picture-outline" @click="delVideo"
                >删除视频</el-button
              >
            </div>
          </div>
        </div>
      </el-row>
    </el-form-item> -->
    <!-- <el-form-item label="视频封面：">
      <el-row>
        <div class="draggable-list">
          <div
            class="item img-select"
            v-if="form.model.poster_id == 0"
            @click="openProductUpload('image', 'poster')"
          >
            <i class="el-icon-plus"></i>
          </div>
          <div
            v-if="form.model.poster_id != 0"
            class="item"
            @click="openProductUpload('image', 'poster')"
          >
            <img :src="form.model.poster.file_path" width="100" height="100" />
          </div>
        </div>
      </el-row>
    </el-form-item> -->
    <!-- <el-form-item label="商品标签：">
      <div class="spec-bd">
        <el-tag
          :key="tag"
          v-for="tag in form.model.shop_label"
          closable
          :disable-transitions="false"
          @close="handleClose(tag)"
        >
          {{ tag }}
        </el-tag>
        <el-input
          class="input-new-tag"
          v-if="inputVisible"
          v-model="inputValue"
          ref="saveTagInput"
          size="small"
          @keyup.enter.native="handleInputConfirm"
          @blur="handleInputConfirm"
        >
        </el-input>
        <el-button v-else class="button-new-tag" size="small" @click="showInput"
          >+ 商品标签</el-button
        >
      </div>
    </el-form-item> -->

    <!-- <el-form-item label="商品卖点：">
      <el-input
        type="textarea"
        v-model="form.model.selling_point"
        class="max-w460"
      ></el-input>
    </el-form-item> -->

    <!--商品图片组件-->
    <Upload
      v-if="isProductUpload"
      :config="config"
      :isupload="isProductUpload"
      @returnImgs="returnProductImgsFunc"
      >上传图片
    </Upload>
  </div>
</template>

<script>
import Upload from "@/components/file/Upload";
import draggable from "vuedraggable";
export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      isProductUpload: false,
      config: {},
      file_name: "image",
      inputVisible: false,
      inputValue: ""
    };
  },
  inject: ["form"],
  created() {
    console.log("------------------");
    console.log(this.form.model.display);
  },
  methods: {
    // 添加标签
    showInput() {
      // shop_label
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.form.model.shop_label.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    handleClose(tag) {
      this.form.model.shop_label.splice(
        this.form.model.shop_label.indexOf(tag),
        1
      );
    },
    /*打开上传图片*/
    openProductUpload: function(file_type, file_name) {
      console.log("执行1", file_type);
      this.file_name = file_name;
      if (file_type == "image") {
        this.config = {
          total: 9,
          file_type: "image"
        };
      } else {
        this.config = {
          total: 1,
          file_type: "video"
        };
      }
      this.isProductUpload = true;
      // 打开商品图片
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      console.log("1234", e, this.file_name);
      if (e != null) {
        if (this.file_name == "video") {
          this.form.model.video_id = e[0].file_id;
          this.form.model.video = e[0];
        } else if (this.file_name == "image") {
          let imgs = this.form.model.image.concat(e);
          this.$set(this.form.model, "image", imgs);
        } else if (this.file_name == "poster") {
          this.form.model.poster_id = e[0].file_id;
          this.form.model.poster = e[0];
        } else if ((this.file_name = "image")) {
          let imgs = this.form.model.spimage.concat(e);
          this.$set(this.form.model, "spimage", imgs);
        }
      }
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index) {
      this.form.model.image.splice(index, 1);
    },
    deleteImg2(index) {
      this.form.model.spimage.splice(index, 1);
    },
    delVideo() {
      this.form.model.video_id = 0;
      this.form.model.video = {};
    },
    /*打开添加*/
    setExpress() {
      this.$router.push("/setting/delivery/index");
    },
    changeDelivery(e) {
      if (e == 0) {
        this.form.model.delivery_id = "";
      }
    }
  }
};
</script>

<style>
.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/product/recovery/commodity/part/Basic.vue